<ion-header>
  <ion-toolbar mode="ios">
    <ion-button
      (click)="close()"
      fill="clear"
      color="dark"
      class="ion-no-padding"
    >
      <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
    </ion-button>
    <ion-title class="ion-no-padding">
      <ion-img
        [src]="dataServ.rData.dark_logo"
        *ngIf="dataServ.rData"
      ></ion-img>
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid>
    <ion-row>
      <ion-col size="12" *ngIf="notificationData.image_url">
        <ion-img [src]="notificationData.image_url"></ion-img>
      </ion-col>
      <ion-col size="12">
        <ion-text color="primary">
          <h1 [innerHtml]="(notificationData.title | caption) | translate"></h1>
        </ion-text>
        <ion-text color="dark">
          <p
            #descriptionElement
            [innerHtml]="(notificationData.description | caption) | translate"
          ></p>
        </ion-text>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="notificationData.type == 'survey'">
      <ion-col size="12" class="stars">
        <ng-container *ngFor="let i of [1, 2, 3, 4, 5]">
          <div
            class="star {{ i <= rate ? 'active' : '' }}"
            (click)="rate = i"
          ></div>
        </ng-container>
      </ion-col>
      <ion-col size="12">
        <ion-button
          [disabled]="processing"
          (click)="send()"
          expand="block"
          color="primary"
        >
          <ion-spinner
            name="lines"
            *ngIf="processing"
            slot="start"
          ></ion-spinner>
          {{ "Send" | translate }}
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
